import React from 'react';
import MostPopular from 'img/marketplace/sidebarIcons/mostPopular.inline.svg';
import New from 'img/marketplace/sidebarIcons/new.inline.svg';
import Marketers from 'img/marketplace/sidebarIcons/marketers.inline.svg';
import UxDesigners from 'img/marketplace/sidebarIcons/uxDesigners.inline.svg';
import Support from 'img/marketplace/sidebarIcons/support.inline.svg';
import Developers from 'img/marketplace/sidebarIcons/developers.inline.svg';
import Analytics from 'img/marketplace/sidebarIcons/analytics.inline.svg';
// import CRM from 'img/marketplace/sidebarIcons/crm.inline.svg';
import CMS from 'img/marketplace/sidebarIcons/cms.inline.svg';
import Ecommerce from 'img/marketplace/sidebarIcons/ecommerce.inline.svg';
import CustomerSupport from 'img/marketplace/sidebarIcons/customerSupport.inline.svg';
import BugTracking from 'img/marketplace/sidebarIcons/bugTracking.inline.svg';
import Surveys from 'img/marketplace/sidebarIcons/surveys.inline.svg';

export const data = [
  {
    category: 'Featured',
    list: [
      {
        title: 'Most popular',
        image: <MostPopular />,
        link: '/integrations/most-popular/',
      },
      {
        title: 'New',
        image: <New />,
        link: '/integrations/new/',
      },
    ],
  },
  {
    category: 'Best for',
    list: [
      {
        title: 'Marketers',
        image: <Marketers />,
        link: '/integrations/for-marketers/',
      },
      {
        title: 'UX Designers',
        image: <UxDesigners />,
        link: '/integrations/for-ux-designers/',
      },
      {
        title: 'Developers',
        image: <Developers />,
        link: '/integrations/for-developers/',
      },
      {
        title: 'Support',
        image: <Support />,
        link: '/integrations/for-support/',
      },
    ],
  },
  {
    category: 'Categories',
    list: [
      {
        title: 'Analytics',
        image: <Analytics />,
        link: '/integrations/analytics/',
      },
      // {
      //   title: 'CRM',
      //   image: <CRM />,
      //   link: '/integrations/crm/',
      // },
      {
        title: 'CMS',
        image: <CMS />,
        link: '/integrations/cms/',
      },
      {
        title: 'E-commerce',
        image: <Ecommerce />,
        link: '/integrations/e-commerce/',
      },
      {
        title: 'Bug tracking',
        image: <BugTracking />,
        link: '/integrations/bug-tracking/',
      },
      {
        title: 'Customer support',
        image: <CustomerSupport />,
        link: '/integrations/customer-support/',
      },
      {
        title: 'Surveys',
        image: <Surveys />,
        link: '/integrations/surveys/',
      },
    ],
  },
];
